import React from 'react';
import { Login } from '../../components/customAuth';

export function LoginPage() {
  return (
    <div style={{ 
      minHeight: '80vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '2rem 0',
      background: '#f5f5f5'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '600px', 
        padding: '0 1rem'
      }}>
        <div style={{ 
          background: 'white', 
          padding: '2rem', 
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          <Login />
        </div>
      </div>
    </div>
  );
}
